import { LazyImage } from '@crehana/compass.ui';
import { usePlayroomRewardsTranslations } from "../../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PlayroomHistoryEmpty = function PlayroomHistoryEmpty() {
  var _usePlayroomRewardsTr = usePlayroomRewardsTranslations(),
    t = _usePlayroomRewardsTr.t;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full",
    children: [/*#__PURE__*/_jsx(LazyImage, {
      src: "https://crehana-vercel-images-prd.imgix.net/public/b5242d92-bf82-4ab5-87e8-a331f2222fb8-group-33167.png",
      alt: "empty",
      className: "tw-mb-2.4 tw-w-14.4 tw-h-14.4",
      isTransparent: true,
      imgClassName: "tw-object-cover",
      imgxParams: {
        w: 144,
        h: 144,
        q: 100,
        fit: 'clip'
      }
    }), /*#__PURE__*/_jsx("h2", {
      className: "tw-font-subtitle4 tw-mb-0.8",
      children: t('PRS_EMPTY_TITLE')
    }), /*#__PURE__*/_jsx("p", {
      className: "tw-font-body4",
      children: t('PRS_EMPTY_DESCRIPTION')
    })]
  });
};
export default PlayroomHistoryEmpty;